export enum AuthorizationType {
    AUTHORIZATION_TOKEN = 'AUTHORIZATION_TOKEN',
    AUTHORIZATION_TOKEN_V2 = 'AUTHORIZATION_TOKEN_V2',
    BEARER_TOKEN = 'BEARER_TOKEN',
    NOT_AUTHORIZED = 'NOT_AUTHORIZED'
}
